import _ from 'lodash';
import $ from 'jquery';
import FormUtil from 'edge/platform/modelvalidation/FormUtil';

let dependentCoverages = [];
let opsInSequence;

function getDependentCoverages() {
    return dependentCoverages;
}

function getDependentCoveragesForLOB(CoverageService, jobNumber) {
    return CoverageService.getDependentCoveragesForLob(jobNumber).then((depCovs) => {
        dependentCoverages = depCovs;

        return depCovs;
    });
}

function getSequencer() {
    opsInSequence = [$.Deferred().resolve()];
    return resolveRequestInSequence;
}

function updateDependentCoverages(coverages, covsToUpdate) {
    const depLOBCoverages = _.filter(coverages, (coverage) => {
        return _.find(dependentCoverages, (depCov) => {
            return depCov.name === coverage.publicID || depCov.dependencies.includes(coverage.publicID);
        });
    });

    _.each(covsToUpdate, (coverage) => {
        coverage = _.find(depLOBCoverages, {publicID: coverage.publicID}) || coverage;

        return coverage;
    });
}

function updateCoverages(updatedCoverage, coverages, covsToUpdate, resetUpdated) {
    let updatedCoverages = coverages;
    if (updatedCoverage) {
        const updatedDependentCov = _.find(dependentCoverages, (depCov) => {
            return depCov.name === updatedCoverage.publicID || _.find(updatedCoverage.terms, {type: depCov.name});
        });
        if (updatedDependentCov) {
            updatedCoverages = _.filter(coverages, (coverage) => {
                return updatedDependentCov.name === coverage.publicID || updatedDependentCov.dependencies.includes(coverage.publicID);
            });
        } else {
            const cov = _.find(updatedCoverages, {publicID: updatedCoverage.publicID});

            if (cov) {
                updatedCoverages = [cov];
            }
        }
    }

    // Remove any coverage that the server has made unavailable
    _.remove(covsToUpdate, (cov) => {
        return !_.find(coverages, {publicID: cov.publicID});
    });

    // Add any coverages that the server has made available
    _.each(coverages, (cov, i) => {
        if (!_.find(covsToUpdate, {publicID: cov.publicID})) {
            covsToUpdate.splice(i, 0, cov);
        }
    });

    return _.each(covsToUpdate, (coverage, i) => {
        coverage = _.find(updatedCoverages, {publicID: coverage.publicID}) || coverage;
        // the changed coverages have now been processed on the server. Mark them as unchanged
        if (resetUpdated) {
            coverage.updated = false;
            coverage.terms.forEach(term => {
                term.updated = false;
            });
        }

        covsToUpdate.splice(i, 1, coverage);
        return coverage;
    });
}

function resolveRequestInSequence(operation) {
    const lastOpInSequence = _.last(opsInSequence);
    const sequencedOp = operation.then(res => lastOpInSequence.then(() => res)); // Force resolve in sequence

    opsInSequence.push(sequencedOp);

    return sequencedOp;
}

function validateForm(form) {
    if (form) {
        FormUtil.markFormsSubmitted(form);

        if (!form.valid) {
            if (form.invalidInputs[0]) {
                $('html, body').animate({
                    scrollTop: $(`#${form.invalidInputs[0]}`).offset().top - 10 // offset by 10px
                }, 300);
            }

            return false;
        }
    }

    return true;
}

/**
 * Takes an object consisting of coverages DTO properties and filters out any coverages that have not been updated (or dont have updated terms)
 * @param {Object} coverages - an object consisting of LOBS with coverage properties. e.g. {businessOwners : {lobCoverages: [] }}
 * @param {array} lobsToFilter - a simple array of strings. If this is defined then only lobs within the list will be filtered
 * @returns {Object} the same structure as allCoverages, but with the coverages reduced. Empty lists are marked as undefined
 */
function filterUnchangedCoverages(coverages, lobsToFilter) {
    const filteredCoverages = _.cloneDeep(coverages);
    for (const lobName of Object.keys(filteredCoverages)) {
        if (!lobsToFilter || lobsToFilter.includes(lobName)) {
            const lob = filteredCoverages[lobName];
            for (const coverageType of Object.keys(lob)) {
                // remove any coverages from the array that have not been updated
                lob[coverageType] = _getFilteredCoverages(lob[coverageType]);
                // for some LOBs there are coverages attached to a coverable at this point (e.g. car.coverages). This will apply the same logic to those coverages
                if (lob[coverageType] && Array.isArray(lob[coverageType])) {
                    for (const subCoverage of lob[coverageType]) {
                        if (subCoverage.coverages) {
                            subCoverage.coverages = _getFilteredCoverages(subCoverage.coverages);
                        }
                    }
                }
            }
        }
    }
    return filteredCoverages;
}

/**
 * Takes an array of coverages and returns only those that have been updated (or have updated terms)
 * @param {array} coverages - an object consisting of coverage properties
 * @returns {array} the same structure as before, but with the coverages reduced
 * @private
 */
function _getFilteredCoverages(coverages) {
    if (Array.isArray(coverages)) {
        const updatedCoverages = _.filter(coverages, (cov) => {
            // return updated coverages or coverages with updated terms. Also return everything that isnt a coverage (i.e. doesnt have coverageCategoryCode)
            return cov.updated === true || _.filter(cov.terms, {updated: true}).length > 0 || !cov.coverageCategoryCode;
        });
        return (updatedCoverages.length > 0) ? updatedCoverages : undefined;
    }
    return coverages;
}

export default () => {

    return {
        getDependentCoverages,
        getDependentCoveragesForLOB,
        updateCoverages,
        updateDependentCoverages,
        getSequencer,
        validateForm,
        filterUnchangedCoverages
    };
};